export const uniqueKeys = (names: Array<string>): Array<string> => {
  const seen = new Map<string, number>();
  return names.map(name => {
    const count = seen.get(name) ?? 0;
    seen.set(name, count + 1);
    return count === 0 ? name : `${name}:${count}`;
  });
};
